import { render, staticRenderFns } from "./integration-card.component.vue?vue&type=template&id=f2f25fca"
import script from "./integration-card.component.vue?vue&type=script&lang=js"
export * from "./integration-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports